import React from "react";
import { Select, Checkbox, Row, Form } from "antd";
import { connect } from "react-redux";
import { hmgGet } from "../../store/actions";

const { Option } = Select;
const rowStyles = { marginBottom: 8 };

const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 },
    md: { span: 8 },
    lg: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 16 },
    md: { span: 12 },
    lg: { span: 10 },
  },
  style: { marginBottom: 0 },
};

class HmgDropdown extends React.Component {
  componentDidMount = async () => {
    // await this.props.hmgGet();
  };

  render() {
    const hmgStyles = this.props.hmgStyles
      ? this.props.hmgStyles
      : formItemLayout;
    return (
      <Form.Item {...hmgStyles} label="Project">
        <Row style={rowStyles}>
          <Select
            showSearch
            placeholder="Please Select Project"
            onChange={async (e) => {
              await this.props.handleHmgChange(e);
              await this.props.loadHotelList(e);
            }}
            value={this.props.hmgSelect}
            style={{ width: "100%", maxWidth: "450px" }}
            filterOption={(input, option) => {
              return (
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              );
            }}
          >
            {Array.isArray(this.props.projectList)
              ? this.props.projectList.map((elem) => {
                  return (
                    <Option key={elem._id} value={elem._id}>
                      {elem.project_name}
                    </Option>
                  );
                })
              : null}
          </Select>
        </Row>
      </Form.Item>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    api: state.api,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hmgGet: () => dispatch(hmgGet()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HmgDropdown);
